// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/monitorManage',
    name: 'MonitorManage',
    component: layout,
    redirect: '/monitorManage/rateAlert',
    meta: {
      title: '采集监控',
      icon: 'i-tabler:activity-heartbeat',
      roles: [0]
    },
    sort: 3,
    children: [
      {
        path: 'index',
        name: 'MonitorManageIndex',
        component: () => import('@/views/Manage/Monitor/Index.vue'),
        hiddenInMenu: true,
        meta: {
          title: '任务采集监控',
          icon: 'i-tabler:chart-line',
          roles: [0]
        }
      },
      {
        path: 'model',
        name: 'MonitorManageModel',
        component: () => import('@/views/Manage/Monitor/ModelDetail.vue'),
        hiddenInMenu: true,
        meta: {
          title: '项目模型明细',
          icon: 'i-tabler:chart-dots-3',
          roles: [0]
        }
      },
      {
        path: 'rateAlert',
        name: 'MonitorManageRateAlert',
        component: () => import('@/views/Manage/Monitor/RateAlert/Index.vue'),
        meta: {
          title: '识别率预警',
          icon: 'i-tabler:alert-triangle',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
